import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { VbLxpPanelComponent } from '../../panel/vb-lxp-panel.component';
import { TimingTowerFullComponent } from '../../timing-tower/timing-tower-full.component';
import { RaceSessionService } from '../../timing-tower/race-session.service';
import { TimingTowerService } from '../../timing-tower/timing-tower.service';
import { VbLxpMapComponent } from '../../map/map.component';

@Component({
	selector: 'vb-lxp-full-timing-page',
	imports: [VbLxpPanelComponent, TimingTowerFullComponent, VbLxpMapComponent],
	templateUrl: './vb-lxp-full-timing-page.component.html',
	styleUrl: './vb-lxp-full-timing-page.component.css',
})
export class VbLxpFullTimingPageComponent {
	public timingTowerService = inject(TimingTowerService);
	public raceSessionService = inject(RaceSessionService);
	public selectedClasses = toSignal(this.raceSessionService.selectedClasses$, { initialValue: [] });

	public openFullMapPage() {
		const currentParams = new URLSearchParams(window.location.search).toString();
		const base = new URL('map-popout', document.baseURI).toString();
		const url = currentParams ? `${base}?${currentParams}` : base;
		const width = 1280;
		const height = 720;
		window.open(url, '_blank', `width=${width},height=${height},resizable=yes`);
	}
}
